import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const BlockquoteButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('blockquote'),
      isDisabled: !editor.can().toggleBlockquote(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleBlockquote().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="quote-left" />}
         title={_js('Insert a quote')}
         shortcut={'shift+b'}
      />
   );
};
